import { useCallback } from "react"
import { useLocation, useNavigate } from "react-router-dom"

export const useReturnPath = (fallback = "/") => {
  const navigate = useNavigate()
  const location = useLocation()

  const from = location.state?.from
  const fromPath =
    (from?.pathname
      ? `${from.pathname}${from.search || ""}${from.hash || ""}`
      : null) ||
    (typeof from === "string" ? from : null) ||
    fallback

  const goBack = useCallback(
    (override = null) => {
      navigate(override || fromPath)
    },
    [navigate, fromPath]
  )

  return { fromPath, goBack }
}

export const navigateWithReturn = (navigate, location, target) => {
  navigate(target, { state: { from: location } })
}
